module.exports = __webpack_public_path__ + "img/BRAVO_5.ab0b79a0.jpg";